var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h18.14l.113 36.17.336-.337L64.276 0h26.315C72.527 15.49 54.457 30.982 36.393 46.471l54.198 44.232H64.052l-9.63-7.614v15.34h36.281v18.141H54.422v50.727l18.14 21.276v-64.276h18.141V215h-18.14L18.14 152.74V215H0v-90.703h18.14l18.141 21.388V116.57H0V98.43h36.281V68.755L18.253 54.534h-.112v36.17H0V0z"}));
}

Logo.defaultProps = {"viewBox":"0 0 91 215"};

module.exports = Logo;

Logo.default = Logo;
